const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { otp: otpApi } = require("@doctoroncallcom/api");
const { OTP_CODE, OTP_CODE_VERIFY } = require("./constants");

const {
  otpCodeSuccess,
  otpCodeError,
  otpCodeVerifySuccess,
  otpCodeVerifyError,
} = require("./actions");

const otpCode = (action$, state$, { api }) =>
  action$.pipe(
    ofType(OTP_CODE),
    mergeMap((action) =>
      otpApi
        .code(api, {
          type: action.payload.type,
          countryCode: action.payload.countryCode,
          phoneNumber: action.payload.phoneNumber,
          email: action.payload.email,
          recaptchaToken: action.payload.recaptchaToken,
        })
        .then((response) => otpCodeSuccess(response.data))
        .catch((error) => otpCodeError(error))
    )
  );
const otpCodeVerify = (action$, state$, { api }) =>
  action$.pipe(
    ofType(OTP_CODE_VERIFY),
    mergeMap((action) =>
      otpApi
        .verify(api, {
          code: action.payload.code,
          sessionId: action.payload.sessionId,
          recaptchaToken: action.payload.recaptchaToken,
        })
        .then((response) => otpCodeVerifySuccess(response.data))
        .catch((error) => otpCodeVerifyError(error))
    )
  );
module.exports = {
  otpCode,
  otpCodeVerify,
};
